import './notification.style.sass';
import template from './notification.tpl.pug';

export default {
    selector: 'dbANotification',
    template: template(),
    transclude: {
        title: 'notificationTitle',
        content: 'notificationContent'
    },
    bindings: {
        imageUrl: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/notifications/component/notification/notification.cmpt.js